export function followUpKind(task) {
  if (task.promised || task.engagementId || ['appointment','engagement'].includes(task.category) || ['promised-call','appointment'].includes(task.automationKey)) return null;
  if (task.automationKey === 'brochure-follow' || /^Relancer après (la )?plaquette/i.test(task.title || '')) return 'brochure';
  if (task.automationKey === 'follow-quote' || /^Relancer le devis/i.test(task.title || '')) return 'quote';
  return null;
}
export function upsertFollowUp(tasks, incoming) {
  const kind = followUpKind(incoming);
  const matches = task => !task.done && !task.cancelled && task.clientId === incoming.clientId && followUpKind(task) === kind &&
    (kind === 'brochure' || (incoming.quoteId ? task.quoteId === incoming.quoteId : !task.quoteId && (task.needId || null) === (incoming.needId || null)));
  const existing = tasks.find(matches);
  if (!existing) return [...tasks, incoming];
  return tasks.map(task => task.id === existing.id ? {...task,...incoming,id:task.id,createdAt:task.createdAt || incoming.createdAt} : matches(task) ? {...task,done:true,cancelled:true,cancelReason:'Relance regroupée',completedAt:incoming.createdAt} : task);
}
